module.exports = __webpack_public_path__ + "img/36.82ad38fd.jpg";